"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestInProgressSubject = void 0;
const to_boolean_1 = require("./operators/to-boolean");
const counter_subject_1 = require("./counter.subject");
class RequestInProgressSubject extends counter_subject_1.CounterSubject {
    loading$() {
        return this.pipe((0, to_boolean_1.toBoolean)());
    }
}
exports.RequestInProgressSubject = RequestInProgressSubject;
